module.exports = __webpack_public_path__ + "static/media/dribbble-btn.a22ade45.png";